import {Link} from 'react-router-dom';
import AnalogStageModelLarge from './analogStageModelLarge';
import {useState, useEffect} from 'react';

function AnalogStage(props) {

    const [version, setVersion] = useState('standard');
    const [paymentLink, setPaymentLink] = useState('https://buy.stripe.com/dRm4gz43V5UPgmbaAK7EQ0k');

    const changeVersion = (e) => {
        setVersion(e.target.value);
    }

    useEffect(() => {
        if (version == 'standard') {
            setPaymentLink('https://buy.stripe.com/dRm4gz43V5UPgmbaAK7EQ0k');
        } else if (version == 'mastering') {
            setPaymentLink('https://buy.stripe.com/7sY00j1VNdnh4Dt10a7EQ0l');
        }
    }, [version]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '40px'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                width: '100%',
                justifyContent: 'center',
                columnGap: '50px'
            }}>
            <div style={{
                width: '350px',
            }}>
            <img src={props.products[0].photo} style={{
                width: '100%',
                borderRadius: '10px'
            }}></img>
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '50%',
                textAlign: 'center'
                
            }}>
            <h1 style={{
                color: '#414243'
            }}>{props.products[0].name}</h1>
            <h2 style={{
                color: '#414243'
            }}>{props.products[0].price}</h2>
            <p style={{
                color: '#414243'
            }}>{props.products[0].description}</p>
            <select onChange={changeVersion}>
                <option value='standard'>standard</option>
                <option value='mastering'>mastering</option>
            </select>
            <a href={paymentLink}><button>pre-order</button></a>
            </div>
            </div>
            <div style={{
                width: '100%',
                height: '400px',
                marginTop: '100px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                //border: '1px solid black'
            }}>
            {/* <AnalogStageModelLarge/> */}
            </div>
        </div>
    )
}

export default AnalogStage;